import request from '@/libs/http/index'

// 部门管理----
// 获取部门信息
export const getDeptInfo = data => {
  return request.get({
    url: `/system/dept/get?id=${data}`,
  })
}
// 更新部门
export const updateDept = data => {
  return request.put({ url: '/system/dept/update', data })
}

// 科室管理----
// 精简科室列表
export const departmentsList = params => {
  return request.get({
    url: `/clinic/departments/list`,
    params,
  })
}
// 科室列表分页
export const departmentsPage = params => {
  return request.get({
    url: `/clinic/departments/page`,
    params,
  })
}
// 新增科室
export const departmentsCreate = data => {
  return request.post({ url: '/clinic/departments/create', data })
}
// 更新科室
export const departmentsUpdate = data => {
  return request.put({ url: '/clinic/departments/update', data })
}
// 删除科室
export const departmentsDelete = data => {
  return request.delete({ url: `/clinic/departments/delete?id=${data}` })
}
// 查询科室详情
export const departmentsDetail = params => {
  return request.get({ url: `/clinic/departments/get`, params })
}

// 成员管理----
// 新增成员
export const tenantCreate = data => {
  return request.post({ url: '/system/user/tenant-create', data })
}
// 更新成员
export const tenantUpdate = data => {
  return request.put({ url: '/system/user/tenant-update', data })
}
// 删除成员
export const tenantDelete = data => {
  return request.delete({ url: `/system/user/delete?id=${data}` })
}
// 获取成员详情
export const tenantDetail = params => {
  return request.get({ url: '/system/user/get', params })
}
// 更新成员密码
export const passwordUpdate = data => {
  return request.put({ url: '/system/user/update-password', data })
}
// 成员列表
export const doctorList = params => {
  return request.get({ url: '/system/user/tenant-page', params })
}
// 查询功能菜单列表
export const getListSimple = (params: any = {}) => {
  return request.get({
    url: `/clinic/inner-menu/tenant-list`,
    params: {
      status: true,
      ...params,
    },
  })
}
// 查询门诊角色分页
export const getInnerRolePage = params => {
  return request.get({ url: `/clinic/inner-role/page`, params })
}

// 证照资质-----
// 获得证照资质
export const getqualificationDetail = params => {
  return request.get({
    url: `/clinic/certification-qualification/get-certification`,
    params,
  })
}
// 更新证照资质
export const qualificationUpdate = data => {
  return request.put({
    url: `/clinic/certification-qualification/update`,
    data,
  })
}

// 加工设置----
// 获取加工方式列表
export const getProcessingSettings = params => {
  return request.get({
    url: `/clinic/settings-processing/page`,
    params,
  })
}
// 绑定微信
export const userBindOpenId = params => {
  return request.get({
    url: `/system/social-user/bindOpenId`,
    params,
  })
}
// 解除绑定微信
export const userUnBindOpenId = data => {
  return request.post({
    url: `/system/social-user/unbind`,
    data,
  })
}
// 医事通验证码
export const ystSendSmsCode = params => {
  return request.get({
    url: `/clinic/yst/send-sms-code`,
    params,
    noErrorTip: true,
  })
}
// 医事通短信绑定
export const ystBindBySms = data => {
  return request.post({
    url: `/clinic/yst/bind-by-sms`,
    data,
  })
}
// 获得医事通绑定状态
export const userBindDetail = params => {
  return request.get({
    url: `/clinic/user-bind/get`,
    params,
  })
}
// 解除医事通绑定
export const userBindDelete = params => {
  return request.delete({
    url: `/clinic/user-bind/delete`,
    params,
  })
}

// 门诊叫号设置----
// 获取门诊叫号设置
export const getCallRuleSetting = () => {
  return request.get({
    url: `/clinic/settings-call-rule/get`,
  })
}

// 更新门诊叫号设置
export const updateCallRuleSetting = data => {
  return request.put({
    url: `/clinic/settings-call-rule/update`,
    data,
  })
}

// 恢复门诊叫号规则默认配置
export const restoreCallRuleSetting = params => {
  return request.get({
    url: `/clinic/settings-call-rule/restore-default`,
    params,
  })
}

export const getDispensingCallRuleSetting = () => {
  return request.get({ url: `/clinic/settings-dispensing-call-rule/get` })
}

export const updateDispensingCallRuleSetting = data => {
  return request.put({ url: `/clinic/settings-dispensing-call-rule/update`, data })
}

// 获取叫号屏幕详情
export const getCallScreen = params => {
  return request.get({
    url: `/clinic/settings-call-screen/get`,
    params,
  })
}
// 获取叫号屏幕分页
export const getCallScreenPage = params => {
  return request.get({
    url: `/clinic/settings-call-screen/page`,
    params,
  })
}
// 创建叫号屏幕
export const createCallScreen = data => {
  return request.post({
    url: `/clinic/settings-call-screen/create`,
    data,
  })
}
// 更新叫号屏幕
export const updateCallScreen = data => {
  return request.put({
    url: `/clinic/settings-call-screen/update`,
    data,
  })
}
// 删除叫号屏幕
export const deleteCallScreen = id => {
  return request.delete({
    url: `/clinic/settings-call-screen/delete?id=${id}`,
  })
}
// 诊室管理----
// 创建诊室
export const consultingRoomCreate = data => {
  return request.post({ url: '/clinic/consulting-room/create', data })
}
// 更新诊室
export const consultingRoomUpdate = data => {
  return request.put({ url: '/clinic/consulting-room/update', data })
}
// 获得诊室分页
export const consultingRoomPage = params => {
  return request.get({ url: '/clinic/consulting-room/page', params })
}
// 获得诊室
export const consultingRoomGet = id => {
  return request.get({ url: `/clinic/consulting-room/get?id=${id}` })
}
// 删除诊室
export const consultingRoomDelete = id => {
  return request.delete({ url: `/clinic/consulting-room/delete?id=${id}` })
}

// 获取ai账号数量
export const deptGetAiCount = params => {
  return request.get({
    url: `/clinic/paid-feature-dept/getAiCount`,
    params,
  })
}
// 是否可使用ai问诊
export const deptCheckAiDiagnosis = params => {
  return request.get({
    url: `/clinic/paid-feature-dept/checkAiDiagnosis`,
    params,
  })
}
// 是否开通医生端
export const deptCheckDoctorApp = params => {
  return request.get({
    url: `/clinic/paid-feature-dept/check-doctor-app`,
    params,
  })
}
